import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { of, catchError } from "rxjs";
import { MarketSegmentModel } from "../models/settings/market-segment.model";
import { TenantContextService } from "./tenant-context.service";

@Injectable({
  providedIn: 'root'
})
export class SegmentTranslationService {
  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private tenantContextService: TenantContextService
  ) {}

  public loadSegmentTranslations(lang: string): void {
    const segment = this.tenantContextService.getMarketSegment();
    if (segment === null || segment === undefined) return;

    const fileName = `/assets/i18n/${lang}.${MarketSegmentModel[segment]}.json`;

    this.http.get(fileName)
      .pipe(catchError(() => of(null)))
      .subscribe(segmentTranslations => {
        if (segmentTranslations) {
          this.translate.setTranslation(lang, segmentTranslations, true);
        }
      });
  }
}